<div class="launch-prompt">
    <div class="launch-icon">
        <img src="../../../assets/images/header-left-logo.svg" alt="J&amp;J MedTech" />
    </div>
    <h2>Open AI Advisor app?</h2>
    <p>Continue in your browser, or open the AI Advisor app for the full experience.</p>
    <div class="launch-actions">
        <button type="button" class="btn-outline" (click)="continueInBrowser()">Continue in Browser</button>
        <button type="button" class="btn-filled" (click)="openInApp()">Open in App</button>
    </div>
</div>
